export const source_destination_types = {
  "Azure Blob Storage Location": "AzureBlobStorageLocation",
  "File Server Location": "FileServerLocation",
};
export const linkedServices = {
  "Upfront On Prem Linked Service": "lsUpfrontOnPrem",
  "DCP Blob Storage Linked Service": "AzureBlobStorage1",
  "OSF Data Lake Linked Service": "OSFDataLakeDev",
};
export const scopes = {
  OCC: "OCC",
  OSFDataLake: "OSFDataLake",
  DCP: "DCP",
  SDOH:"SDOH"
};
export const fileTypes = {
  CSV: "csv",
  TEXT: "text",
  JSON: "json",
  EXCEL: "excel",
  TXT: "txt",
};
export const columnDelimiters = {
  "Comma(,)": ",",
  "Semicolon(;)": ";",
  "Pipe(|)": "|",
  "Tab(\\t)": "\\t",
  "Start of the Heading(\\u0001)": "\\u0001",
};
